var map = {
	"./Lead.svg": "28f9",
	"./Stal-line.svg": "969f",
	"./Star-filled.svg": "24ba",
	"./Star_line.svg": "2423",
	"./Star_solid.svg": "4317",
	"./actions.png": "b077",
	"./arrow-active.svg": "9157",
	"./arrow-inactive.svg": "5d56",
	"./auth-img.svg": "84cc",
	"./basil_edit-outline.svg": "25d5",
	"./carbon_warning-square.svg": "9349",
	"./charm_tick.svg": "e2fe",
	"./credit-card.svg": "db51",
	"./dashboard.png": "5b2d",
	"./dashboard.svg": "79e8",
	"./delete-v2 2.svg": "b682",
	"./delete-v2.svg": "5800",
	"./deliver.svg": "61cf",
	"./edit1.png": "7ad8",
	"./excel.svg": "981f",
	"./eye.svg": "35f9",
	"./format-list-group.svg": "0230",
	"./guide.svg": "771d",
	"./headphones.svg": "d0e5",
	"./humberger-menu.svg": "a033",
	"./ic_round-headset-mic-yellow.svg": "5e3b",
	"./ic_round-headset-mic.svg": "f5fe",
	"./lock.svg": "46b6",
	"./material-symbols_folder-open-outline-rounded.svg": "8f86",
	"./mdi_format-list-group-plus.svg": "3a84",
	"./mdi_format-list-group.svg": "3a4a",
	"./mdi_person-multiple.svg": "6089",
	"./notification.svg": "e61d",
	"./outline-insert-comment.svg": "1fa4",
	"./outline-mode-comment.svg": "0ec9",
	"./pakshoma/shop-pa.svg": "6d7e",
	"./pakshoma/user-pa.svg": "0395",
	"./pakshoma/visits-pa.svg": "72d4",
	"./person-multiple.svg": "3c08",
	"./plus-black.svg": "66df",
	"./plus-green.svg": "6bd5",
	"./plus-square.svg": "d195",
	"./plus-white.svg": "8e5b",
	"./plus.svg": "a700",
	"./red-trash.svg": "7150",
	"./refresh-white.svg": "5f88",
	"./refresh.svg": "76bf",
	"./relocate.svg": "4edf",
	"./search-black.svg": "b29d4",
	"./search-white.svg": "29d0",
	"./select-project.svg": "5b2d2",
	"./shopping-bag.svg": "1015",
	"./solar_add-square-broken.svg": "7ddf",
	"./solar_play-broken.svg": "1040",
	"./tabler_send.svg": "c9ad",
	"./tick.svg": "3a95",
	"./transaction.svg": "05ba",
	"./trash-icon.png": "4378",
	"./trash.png": "9584",
	"./uil_calender-yellow.svg": "dea0",
	"./uil_calender.svg": "2d9a",
	"./upload.svg": "fa35",
	"./upload_noback.svg": "7514",
	"./use.svg": "00c4",
	"./user-menu.svg": "058a",
	"./user.svg": "5b2f",
	"./warning.svg": "29ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6152";